import React from "react";
import NewsCard from "../NewsCard/NewsCard";
import AdSlot from "../AdSlot/AdSlot";
import "./NewsGrid.css";

/**
 * Renders a hero (first) story plus a responsive grid of remaining cards,
 * with ad slots woven in: one leaderboard after the hero, then one
 * in-feed unit every 6 cards.
 * newsList: array of news objects (see NewsCard for shape)
 */
function NewsGrid({ newsList, showHero = true, showAds = true, adFrequency = 6 }) {
  if (!newsList || newsList.length === 0) {
    return <p className="tt-grid-empty">No news articles to show right now.</p>;
  }

  const [heroItem, ...restItems] = newsList;
  const items = showHero ? restItems : newsList;

  return (
    <div className="tt-grid-wrap">
      {showHero && heroItem && (
        <div className="tt-grid-hero">
          <NewsCard news={heroItem} variant="hero" />
        </div>
      )}

      {showAds && <AdSlot slot="1111111111" variant="leaderboard" label="Advertisement" />}

      <div className="tt-grid-cards">
        {items.map((news, index) => (
          <React.Fragment key={`${news.categorySlug}-${news.id}`}>
            <NewsCard news={news} />
            {showAds && (index + 1) % adFrequency === 0 && index !== items.length - 1 && (
              <div className="tt-grid-ad-cell">
                <AdSlot slot="2222222222" variant="in-feed" label="Advertisement" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default NewsGrid;
